import React, { Component } from "react";

import { Button, FormGroup, Form, Checkbox, ButtonGroup, Modal } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSVLink, CSVDownload } from "react-csv";

import "./style.css";

import AddUser from "../settings-add-user";
import EditUser from "../settings-edit-user";

import UsersService from "../../services/users-service";
import {ToastContainer, ToastStore} from 'react-toasts';
import SettingsModal from "../settings-alert";
import moment from 'moment';
class UsersData extends Component {

    tableData = {
        columns: [
          {
            label: 'Username',
            field: 'username',
            sort: 'asc',
            width: 150
          },
          {
            label: 'Full Name',
            field: 'full_name',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Branch',
            field: 'branch',
            sort: 'asc',
            width: 200
          },
          {
            label: 'Email',
            field: 'submit_email',
            sort: 'asc',
            width: 100
          },
          {
            label: 'User Type',
            field: 'user_type',
            sort: 'asc',
            width: 150
          }
        ],
        rows: []
    }

    csvData = [
        ["Employee ID", "First Name", "Last Name", "Email", "Home Branch", "Username", "Password", "Employee ID",
        "Cell Phone", "Work Phone", "Address", "City", "State", "Zip Code", "Birth Date", "Hire Date", "Notes"],
      ];

    deleteFormatter = (cell, row, rowIndex, formatExtraData) => {
        const rowId = row.recno;
        return (
                <Button onClick={()=> this.handleDeleteUser(rowId) }>
                    <FontAwesomeIcon className="" icon="trash-alt"/>
                </Button>
        );
    }

    activeFormatter = (cell, row, rowIndex, formatExtraData) => {
        const checked = row.active == 1? true : false;

        return (
                <Form>
                    <FormGroup>
                        <Checkbox id="active"
                            defaultChecked={checked}
                            onChange={()=> this.handleActiveStatusChange(row)}
                            onClick={()=> this.deleteItemClicked = true}>Active</Checkbox>
                    </FormGroup>
                </Form>
        );
    }

    lmsFormatter = (cell, row, rowIndex, formatExtraData) => {
        const rowId = row.id;
        return (
                <Form>
                    <FormGroup >
                        <Checkbox id="active" className="col-md-offset-5" defaultChecked={row.lms == 1 ? true : false} disabled></Checkbox>
                    </FormGroup>
                </Form>
        );
    }

    usernameFormatter = (cell, row, rowIndex, formatExtraData) => {
      return <div style={{cursor: "pointer"}}>{cell}</div>
    }

    constructor(props) {
        super(props);

        this.handleAddUser = this.handleAddUser.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.handleUploadUsers = this.handleUploadUsers.bind(this);
        this.cancelUsersUpload = this.cancelUsersUpload.bind(this);
        this.submitUsersUpload = this.submitUsersUpload.bind(this);
        this.handleActiveUserFilter = this.handleActiveUserFilter.bind(this);
        this.handleInactiveUserFilter = this.handleInactiveUserFilter.bind(this);
        this.fetchUsers = this.fetchUsers.bind(this);
        this.performUsersUpload = this.performUsersUpload.bind(this);
        this.getBranchID = this.getBranchID.bind(this);


        this.deleteItemClicked = false;
        this.filterActiveEmployees = true;
        this.filesInput = null;

        const credentials =  UsersService.sharedInstance.getStoredCredentials().loginResponse;


        this.state = {
            mode: "default",
            token: credentials.token_data.token,
            auth_username: credentials.data[0].User_ID,
            license: credentials.data[0].User_License,
            data: this.tableData,
            showUpload: false,
        }

        this.fetchUsers();

        this.options = {
            onRowClick: (row) => this.editUser(row),
            hideSizePerPage: true,
            defaultSortName: 'username',  // default sort column name
            defaultSortOrder: 'asc'  // default sort order
        }
    }

    handleAddUser() {
        this.setState({mode: "add_user"});
        //this.setState({mode: "edit_user"});
    }

    handleUploadUsers() {
        this.setState({showUpload: true});
    }

    handleDeleteUser(user_id){
        this.deleteItemClicked = true;

        var params = {
            "id": user_id,
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.auth_username
        }


        UsersService.sharedInstance.delete_user(params)
        .then((response)=>{
            var responseData = JSON.stringify(response);

            if (response.success == 1 || response == true){
                this.deleteItemClicked = false;
                ToastStore.success("Successfully deleted user!");
                this.fetchUsers();
            }
            else {
                ToastStore.error("Error: " + response.message);
            }
        })
        .catch((error)=>{
            console.log("Error deleting user", error);
        })
    }

    handleActiveStatusChange(row){
        this.deleteItemClicked = true;

        const active_status = row.active == 1? 0 : 1;

        //Add API Call here
        let params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.auth_username,
            "recno": row.recno,
            "is_active": active_status,
        }

        // Use this for the meantime:
        setTimeout(function() { //Start the timer
            this.deleteItemClicked = false;
        }.bind(this), 1000)

        UsersService.sharedInstance.update_user_status(params)
        .then((response)=>{

            var responseData = JSON.stringify(response);

            if (response == true){
                this.deleteItemClicked = false;
                ToastStore.success("Successfully modified user active status!");
                this.fetchUsers();
            }
            else {
                ToastStore.error("Error: " + response.message);
            }
        })
        .catch((error)=>{
            console.log("Error updating user active status", error);
        })

    }

    cancelUsersUpload(){
        this.setState({showUpload: false});
    }

    handleCSVChange = (event) => {
        this.csv = event.target.files[0];
    }

    submitUsersUpload(){
        var Papa = require('papaparse');
        var license = this.state.license;


        let params = {
            "license":this.state.license,
            "auth_username":this.state.auth_username,
            "token":this.state.token,
            "users":[]
        };

        if(this.csv != null) {
          Papa.parse(this.csv, {
              complete: (results)=>{

                  var users_array = [];

                  // Handle storing here.
                  results.data.map((item, index)=>{

                      if (index > 0){
                          var branch_id = null;

                          this.props.branches.map((branch)=>{
                              if (branch.Value == item[4]){
                                  branch_id = branch.recno;
                              }
                          });

                          const user_type = UsersService.sharedInstance.getUserTypeToUpload(item[7]);
                          const user = {
                              "license": license,
                              "employee_id": item[0],
                              "full_name": item[1] + ' ' + item[2],
                              "first_name": item[1],
                              "last_name": item[2],
                              "email": item[3],
                              "branch": branch_id,
                              "username": item[5],
                              "password": item[6],
                              "mobile_phone": item[8],
                              "work_phone": item[9],
                              "address": item[10],
                              "city": item[11],
                              "state": item[12],
                              "zipcode": item[13],
                              "date_of_birth": item[14] != null && item[14] != "" ? moment(item[14]).format("YYYY-MM-DD") : null,//item[14],
                              "hire_date": item[15] != null && item[15] != "" ? moment(item[15]).format("YYYY-MM-DD") : null,//item[15],
                              "notes": item[16],
                              "submit_email": "",
                              "cc_email": "",
                              "from_email":"",
                              "user_type":user_type,
                          }

                          const myObjStr = user;
                          users_array.push(myObjStr);
                      }
                  });
                  params.users = JSON.stringify(users_array);
                  this.performUsersUpload(params);
              }
          });

          this.setState({showUpload: false});
        } else {
          ToastStore.error("No CSV selected yet!");
        }

    }

    performUsersUpload(params){
        UsersService.sharedInstance.uploadUsers(params)
        .then((response)=>{
            if (response.success == 1){
                this.fetchUsers();
                ToastStore.success("Successfully Uploaded Users!");
            }
        });
    }

    getBranchID(branch_name){
        this.props.branches.map((item)=>{
            if (item.Value == branch_name){
                return item.recno;
            }
        })
    }

    fetchUsers(){
        var is_active = this.filterActiveEmployees == true ? 1 : 0;
        UsersService.sharedInstance.fetchUsers(this.state.license, this.state.auth_username, this.state.token, is_active)
        .then((response)=>{

            var responseData = JSON.stringify(response);
            this.tableData.rows = [];
            this.csvData = [
                ["Employee ID", "First Name", "Last Name", "Email", "Home Branch", "Username", "Password",'User Type',
                "Cell Phone", "Work Phone", "Address", "City", "State", "Zip Code", "Birth Date", "Hire Date", "Notes"],
            ];

            response.map((item)=>{
                const user_type = UsersService.sharedInstance.getUserType(item.User_Type);
                var employee_id = UsersService.sharedInstance.returnEmptyIfNull(item.employee_id);
                var item_data = {
                    "recno": UsersService.sharedInstance.returnEmptyIfNull(item.recno),
                    "username":  UsersService.sharedInstance.returnEmptyIfNull(item.User_ID),
                    "first_name": UsersService.sharedInstance.returnEmptyIfNull(item.first_name),
                    "last_name": UsersService.sharedInstance.returnEmptyIfNull(item.last_name),
                    "branch": UsersService.sharedInstance.returnEmptyIfNull(item.branch),
                    "email": UsersService.sharedInstance.returnEmptyIfNull(item.email),
                    "user_type": user_type,
                    "lms": UsersService.sharedInstance.returnEmptyIfNull(item.lms_user_id) ? 1 : null,
                    "active": UsersService.sharedInstance.returnEmptyIfNull(item.is_active)
                };
                this.tableData.rows.push(item_data);
                this.csvData.push([employee_id, item.first_name, item.last_name, item.email, item.branch, item.User_ID, item.Password, user_type,
                    item.mobile_phone, item.work_phone, item.address, item.city, item.state, item.zipcode, item.date_of_birth && item.date_of_birth !== "0000-00-00"? moment(item.date_of_birth).format("MM-DD-YYYY") : "",
                    item.hire_date && item.hire_date !== "0000-00-00" ? moment(item.hire_date).format("MM-DD-YYYY"): "", item.notes]);
            });
            this.setState({data: this.tableData});
        })
        .catch((error)=>{
            console.log("Error fetching users", error);
        })
    }

    componentDidUpdate() {
        // this.fetchUsers();
    }

    render(){
        return (
            <div className="users-table-content">
                {this.renderDisplay()}
                {this.renderUploadModal()}
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
            </div>
        )
    }

    renderDisplay(){
        switch(this.state.mode){
            case "add_user":
                return (
                    <AddUser branches={this.props.branches} pageChange={this.pageChange}/>
                );
            case "edit_user":
                return (
                    <EditUser branches={this.props.branches} pageChange={this.pageChange} user={this.state.user}/>
                );
            default:
                return (
                    <div>
                        {this.usersList()}
                    </div>
                )
        }
    }

    renderUploadModal(){
        return (
            <Modal style={{marginTop: "10%"}} show={this.state.showUpload} onHide={()=>{}}>
                <Modal.Body className="upload-modal-body">
                    <h3 className="modal-title">Upload Users</h3>
                    {/* <input type="file" id="file" ref="fileUploader" className="form-control"/> */}
                    <input
                        type="file"
                        ref={(input) => { this.filesInput = input }}
                        name="file"
                        icon='file text outline'
                        label='Upload CSV'
                        placeholder='Upload CSV File...'
                        className="form-control"
                        onChange={this.handleCSVChange}
                    />
                    <Button className="gray-btn upload-logo-btn" onClick={this.cancelUsersUpload}>Cancel</Button>
                    <Button className="green-btn upload-logo-btn" onClick={this.submitUsersUpload}>Upload</Button>
                    <hr className="hr-divider"/>
                    {
                      //
                      // <h3>OR</h3>
                      // <div className="droppable-area">
                      //     <h3>Drag and Drop to Upload</h3>
                      // </div>
                    }

                    {/* <a href="#" className="download-link">Download CSV Template</a> */}
                </Modal.Body>
            </Modal>
        )
    }

    handleInactiveUserFilter(){
        this.filterActiveEmployees = false;
        this.fetchUsers();
        this.setState({mode: 'default'});
    }

    handleActiveUserFilter(){
        this.filterActiveEmployees = true;
        this.fetchUsers();
        this.setState({mode: 'default'});
    }

    usersList(){
        return(
            <div>
                <div className="users-controls">
                    <Button className="comm-log-btn green-btn" onClick={this.handleAddUser}>Add User</Button>
                    <Button className="comm-log-btn blue-btn" onClick={this.handleUploadUsers}>Upload Users</Button>
                    <CSVLink filename={"Users.csv"} className="blue-btn no-line" data={this.csvData}>Download Users</CSVLink>
                </div>

                <div className="users-table">

                    <div className="active-filter">
                        <h5>Filter Users:</h5>

                        <ButtonGroup className="mt-3">
                            <Button variant="secondary" className={this.filterActiveEmployees == true ? 'active':''} onClick={this.handleActiveUserFilter}>Active</Button>
                            <Button variant="secondary" className={this.filterActiveEmployees == false ? 'active':''} onClick={this.handleInactiveUserFilter}>Inactive</Button>
                        </ButtonGroup>
                    </div>

                    <BootstrapTable width="100%" data={ this.tableData.rows } hover={true} keyField="recno" search={true} pagination options={this.options} trClassName={"usersRow"}>
                        <TableHeaderColumn dataSort dataField='username' width="100px" dataFormat={this.usernameFormatter}>Username</TableHeaderColumn>
                        <TableHeaderColumn dataSort dataField='first_name' width="100px">First Name</TableHeaderColumn>
                        <TableHeaderColumn dataSort dataField='last_name' width="100px">Last Name</TableHeaderColumn>
                        <TableHeaderColumn dataSort dataField='branch' width="100px">Branch</TableHeaderColumn>
                        <TableHeaderColumn dataSort dataField='email' width="200px">Email</TableHeaderColumn>
                        <TableHeaderColumn dataSort dataField='user_type' width="100px">User Type</TableHeaderColumn>
                        <TableHeaderColumn dataField='lms' width="80px" dataFormat={this.lmsFormatter}>e-Learning</TableHeaderColumn>
                        <TableHeaderColumn dataField='active' width="80px" dataFormat={this.activeFormatter}>Active</TableHeaderColumn>
                        <TableHeaderColumn dataField='' width="50px" dataFormat={this.deleteFormatter}></TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        )
    }

    pageChange(mode){

        if (mode == 'default'){
            this.fetchUsers();
        }

        this.setState({mode: mode});
    }

    editUser(userClicked){
       // var user = this.state.data.rows[index];
        if (this.deleteItemClicked == true){
            return;
        }

        var user = userClicked;
        // console.log('should edit user ', user);

        this.setState({mode: "edit_user", user: user});
    }
}

export default UsersData;
